var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 6.07812C7.25 5.66391 7.58579 5.32813 8 5.32813L20 5.32813C20.4142 5.32813 20.75 5.66391 20.75 6.07813C20.75 6.49234 20.4142 6.82813 20 6.82813L8 6.82813C7.58579 6.82813 7.25 6.49234 7.25 6.07812Z",
    fill: "#2E4D6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51173 5.51968C4.81961 5.79678 4.84457 6.271 4.56748 6.57888L4.55748 6.58999C4.28038 6.89787 3.80616 6.92283 3.49828 6.64574C3.1904 6.36864 3.16544 5.89442 3.44254 5.58654L3.45254 5.57543C3.72963 5.26755 4.20385 5.24259 4.51173 5.51968Z",
    fill: "#2E4D6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51173 11.5197C4.81961 11.7968 4.84457 12.271 4.56748 12.5789L4.55748 12.59C4.28038 12.8979 3.80616 12.9228 3.49828 12.6457C3.1904 12.3686 3.16544 11.8944 3.44254 11.5865L3.45254 11.5754C3.72963 11.2675 4.20385 11.2426 4.51173 11.5197Z",
    fill: "#2E4D6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51173 17.5197C4.81961 17.7968 4.84457 18.271 4.56748 18.5789L4.55748 18.59C4.28038 18.8979 3.80616 18.9228 3.49828 18.6457C3.1904 18.3686 3.16544 17.8944 3.44254 17.5865L3.45254 17.5754C3.72963 17.2675 4.20385 17.2426 4.51173 17.5197Z",
    fill: "#2E4D6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12.0781C7.25 11.6639 7.58579 11.3281 8 11.3281L20 11.3281C20.4142 11.3281 20.75 11.6639 20.75 12.0781C20.75 12.4923 20.4142 12.8281 20 12.8281L8 12.8281C7.58579 12.8281 7.25 12.4923 7.25 12.0781Z",
    fill: "#2E4D6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 18.0781C7.25 17.6639 7.58579 17.3281 8 17.3281L20 17.3281C20.4142 17.3281 20.75 17.6639 20.75 18.0781C20.75 18.4923 20.4142 18.8281 20 18.8281L8 18.8281C7.58579 18.8281 7.25 18.4923 7.25 18.0781Z",
    fill: "#2E4D6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.aaf0ec47f8db88bcacdaf2621e95bf8d.svg";
export { ForwardRef as ReactComponent };